.root {
    width: 100%;
    height: 100%;

    display: grid;
    grid-template-columns: 100%;
    grid-template-rows: 1.5fr 1fr;
    grid-template-areas: "canvas" "upgrades";

    @media (aspect-ratio < .6) {
        grid-template-rows: auto 1fr;
    }

    @media (width > 768px) {
        padding: 20px;
        gap: 20px;
        grid-template-columns: auto auto;
        grid-template-rows: 1fr;
        grid-template-areas: "upgrades canvas";
    }
}

.sidebarContainer {
    grid-area: upgrades;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    min-height: 0;
}

.upgradesContainer {
    display: grid;
    grid-template-columns: auto auto auto;
    row-gap: 10px;
    column-gap: 10px;

    @media (width > 768px) {
        column-gap: 20px;
    }

    overflow: auto;

    & > * {
        grid-column: 1 / 4;
    }
}

.upgradesHeader {
    display: grid;
    grid-template-columns: subgrid;
    align-items: center;
    padding: 10px 20px;
    margin-bottom: -10px;

    position: sticky;
    top: 0;
    z-index: 1;
    background: hsl(0 0% 7% / 50%);
    box-shadow: inset 0 12px 10px -10px #111;
    backdrop-filter: blur(2);

    text-align: end;
    font-weight: 500;
    font-size: 0.8em;

    :first-child {
        text-align: start;
    }
}

.canvasContainer {
    grid-area: canvas;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 0;

    canvas {
        max-width: 100%;
        max-height: 100%;
        box-shadow: 0 0 0 1px #43457b;
    }
}
